<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="-1"
      absolute
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="2">
        <v-btn color="#7BC243" to="/ccarf/farmer/loan/schedule" class="white--text cataloguebtn">View All Schedules</v-btn>
      </v-col>
    </v-row>
    <v-layout>
      <v-flex xs12>
        <div :class="paginatedItems.length === 7 ? 'catalogued_box' : 'catalogued_box_empty'">
          <v-card-text>
            <h5 class="accent--text" style="font-size: 12px; font-weight:700"> Loan Schedule </h5>
            <table class="table">
              <thead class="thead">
              <tr>
                <th scope="col">MEMBER NAME</th>
                <th scope="col">ID NO</th>
                <th scope="col">MEMBER NO</th>
                <th scope="col">PHONE NO</th>
                <th scope="col">BANK CODE</th>
                <th scope="col">ACCOUNT NAME</th>
                <th scope="col">ACCOUNT NUMBER</th>
                <th scope="col">AMOUNT</th>
                
<!--                <th scope="col">LIMIT AMOUNT</th>-->

              </tr>
              </thead>
              <tbody>
              <tr v-for="item in paginatedItems" v-bind:key="item.id">
                <td> {{ item.memberName }}</td>
                <td> {{ item.idNumber }}</td>
                <td> {{ item.memberNo }}</td>
                <td> {{ item.phoneNumber }}</td>
                <td> {{ item.bankCode }}</td>
                <td>{{ item.currentDelivery }}</td>
                <td>{{ item.bankAccount }}</td>
                
<!--                <td>{{ item.limitAmount }}</td>-->
                <td>{{ item.amount }}</td>
              </tr>
              </tbody>
            </table>
          </v-card-text>
          <v-card-actions>
            <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
            <v-spacer></v-spacer>
            <v-pagination
              v-model="page"
              :length="numberOfLinks"
              :total-visible="7"
              color="secondary"
                class="accent--text logoutbtn"
            ></v-pagination>
          </v-card-actions>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'

export default {
	name: 'loan_schedule_details',
	data: function () {
		return {
			items: [],
			message: '',
			loading: false,
			snackbar: false,
			snackbarColor: '',
			messsage: '',
			paginatedItems: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1
		}
	},
	watch: {
		items: function () {
			this.numberOfLinks = Math.ceil(this.items.length / this.numberOfItemsPerPage)
			this.paginatedItems = this.paginationMethod(this.items, 1, this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedItems = this.paginationMethod(this.items, val, this.numberOfItemsPerPage)
		}
	},
	mounted () {
		this.getLimitDetails()
	},
	methods: {
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		getLimitDetails () {
			const url = config.serverURI + '/upload/cherry/loanSchedule/' + this.$route.params.id
			axios.get(url)
				.then(response => {
					this.items = response.data
				})
				.catch(error => {
					console.log('error', error.response)
					this.snackbar = true
					this.snackbarColor = 'error'
					this.message = error.response.data.error
				})
		}
	}
}

</script>
<style>
.catalogued_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogued_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogued_box:after, .catalogued_box:before {
  right: 100%;
  top: 23%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogued_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}

.catalogued_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}
</style>
